<template>
  <div class="grey lighten-5 fill-height">
    <Invitation />
    <toaster />
  </div>
</template>
<script>
import Invitation from '/src/components/pages/Invitation/new'
import Toaster from '@/components/commons/Toaster'

export default {
  components: { Invitation, Toaster }
}
</script>
